import {
    FETCH_SOS,
    FETCH_SOS_SUCCESS,
    FETCH_SOS_FAILED,
    EDIT_SOS
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import { onValue, push, update } from "firebase/database";

  /** Estados de una alerta SOS. Las alertas sin `status` están pendientes. */
  export const SOS_STATUSES = ['pending', 'in_progress', 'resolved', 'false_alarm'];

  export const sosStatusOf = (sos) => (sos && SOS_STATUSES.includes(sos.status) ? sos.status : 'pending');

  export const fetchSos = () => (dispatch) => {
  
    const {
        sosRef
    } = firebase;
  
    dispatch({
      type: FETCH_SOS,
      payload: null
    });
   onValue(sosRef, snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i
          return data[i]
        });
        dispatch({
          type: FETCH_SOS_SUCCESS,
          payload: arr.reverse()
        });
      } else {
        dispatch({
          type: FETCH_SOS_FAILED,
          payload: "No SOS available."
        });
      }
    }, () => {
      dispatch({
        type: FETCH_SOS_FAILED,
        payload: "No SOS available."
      });
    });
  };

  export const editSos = (reasons, method) => (dispatch) => {

    const {
        sosRef
    } = firebase;
  
    dispatch({
      type: EDIT_SOS,
      payload: {method, reasons}
    });
    
    if (method === 'Add') {
      const { auth } = firebase;
      const uid = auth && auth.currentUser ? auth.currentUser.uid : null;
      push(sosRef, uid ? { ...reasons, uid } : reasons);
    }
  }

  /** Admin: cambia el estado de la alerta y deja registro de quién la gestionó. */
  export const updateSosStatus = (id, status, note) => {
    const { editSosRef, auth } = firebase;
    if (!SOS_STATUSES.includes(status)) return Promise.reject(new Error('invalid_status'));
    const user = auth && auth.currentUser;
    const now = Date.now();
    const patch = {
      status,
      statusUpdatedAt: now,
      attendedBy: user ? user.uid : null,
      attendedByEmail: user ? user.email || null : null,
    };
    if (note !== undefined) patch.adminNote = String(note || '').trim().slice(0, 500) || null;
    if (status === 'resolved' || status === 'false_alarm') {
      patch.processed = true;
      patch.processDate = now;
    } else {
      patch.processed = null;
      patch.processDate = null;
    }
    return update(editSosRef(id), patch);
  };
